import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AbpModule } from 'abp-ng2-module';
import { PwaInstallService } from '@shared/service-proxies/EventEmitterService';

@Component({
  selector: 'app-install-popup',
  templateUrl: './app-install-popup.component.html',
  styleUrls: ['./app-install-popup.component.css'],
  standalone: true,
  imports: [FormsModule, AbpModule, CommonModule, RouterModule]
})
export class AppInstallPopupComponent implements OnChanges {

  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  context: { browser: string; device: string; os: string };
  isMobile: boolean = false;

  constructor(public pwa: PwaInstallService) {
    this.context = this.pwa.getContext();
    this.isMobile = this.pwa.isMobile();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible']) {
      // 👇 whenever parent updates `visible`, you can react here
      const newVal = changes['visible'].currentValue;
      // if you want to sync or perform side effects, do it here
      this.visible = newVal;
    }
  }

  async install() {
    if (this.pwa.canPromptInstall()) {      
      this.close();
      const accepted = await this.pwa.promptInstall();
      if (accepted) this.visible = false;
    }
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

}
